// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Checkbox,
//   Menu,
//   MenuItem,
//   Modal,
//   OutlinedInput,
//   Pagination,
//   CircularProgress,
//   PaginationItem,
//   Select,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   tableCellClasses,
//   IconButton,
// } from "@mui/material";
// import {
//   DatePickerStyle,
//   PrimaryTypography,
//   SecondaryTypography,
//   StyledOutlinedInput,
//   StyledSecondaryTypography,
//   StyledTableCell,
//   StyledTableRow,
//   StyledTypography,
//   TypographyDefault,
//   StyledSecondaryBookingTypography,
// } from "../../Theme";
// import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
// import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
// import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
// import { ReactComponent as CsvIcon } from "../../Icons/CsvIcon.svg";
// import { ReactComponent as PdfIcon } from "../../Icons/PdfIcon.svg";
// import { ReactComponent as DownloadIcon } from "../../Icons/DownloadIcon.svg";
// import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
// import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
// import { ReactComponent as DeleteIcon } from "../../Icons/DeleteTable.svg";
// import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
// import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
// import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
// import { ReactComponent as MoreIcon } from "../../Icons/ThreeDot.svg";
// import { ReactComponent as Close } from "../../Icons/BorderAlertClose.svg";
// import { ReactComponent as DisabledDownloadIcon } from "../../Icons/DisableDownload.svg";
// import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
// import { AccessHistoryAllTabColumn } from "../../Data";
// import { saveAs } from "file-saver";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import axiosInstance from "../../Redux/AxiosInstance";
// import moment from "moment";
// import { getChip } from "../../Utils";
// import TypesInformationModal from "../../CommonComponents/TypeInformationModal";
// import { DatePicker } from "@mui/x-date-pickers";
// import { showToast } from "../../CommonComponents/Toaster";
// import ModeEditIcon from '@mui/icons-material/ModeEdit';
// import AlertModal from "../../CommonComponents/modal";
// import { toast, ToastContainer } from "react-toastify";
// import dayjs from "dayjs";
// import CustomDateRangePicker from "../../CommonComponents/CustomDateRange";

// const VisitorAccessReports = () => {
//   const [initialRender, setInitialRender] = useState(true);
//   const { propertyId } = useSelector((state) => state.PropertyDetails);
//   const [openDateRangePicker, setopenDateRangePicker] = useState(false);
//   const { userDetails } = useSelector((state) => state.Login);
//   const tabList = ["All", "Invited", "Ad-hoc"];
//   const [TabId, setTabId] = useState("");
//   //(TabId);
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedTab, setSelectedTab] = useState("All");
//   const [VisitorsList, setVisitorsList] = useState([]);
//   const [rowsPerPage, setRowsPerPage] = useState("10");

//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const [sortAnchorEl, setSortAnchorEl] = useState(null);
//   const sortOpen = Boolean(sortAnchorEl);
//   const [sortData, setSortData] = useState(null);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);
//   const filterOpen = Boolean(filterAnchorEl);
//   const [paginationData, setPaginationData] = useState({});
//   const [showAnchorEl, setshowAnchorEl] = useState(null);
//   const showOpen = Boolean(showAnchorEl);
//   const [SearchData, setSearchData] = useState("");
//   const [Tableloading, setTableloading] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [showDeleteModal, setshowDeleteModal] = useState(false);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//    const [dateSubmit, setdateSubmit] = useState(false);
//    //(dateSubmit);
//   const userRoles = {
//     '2' : 'BMO Admin',
//     '3' : 'Concierge',
//     '4' : 'Security',
//     '5' : 'Manager',
//   }
//   const [datetimerangedata, setdatetimerangedata] = useState([null, null]);

//   let name ="", id = "";
//   let deleteModalDatas = {
//     label:  "Delete User",
//     descriptionOne:  `User will be removed from the list.`,
//     buttonOne: {
//       variant: "outlined",
//       color: "#800000",
//       backgroundColor: "#FFFFFF",
//       text: "Cancel",
//     },
//     buttonTwo: {
//       variant: "contained",
//       color: "#FFFFFF",
//       backgroundColor: "#B42318",
//       text: "Delete Now",
//     },
//   };

// //   const getAllVisitors = async () => {
// //     setTableloading(true);
// //     setVisitorsList([]);
// //     try {
// //       const response = await axiosInstance.get(
// //         `${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&sort=${sortData}&type_id=${TabId}&search=${SearchData}`
// //       );
// //       setVisitorsList(response.data.data.invite_visitor);
// //       setPaginationData(response.data.data.pagination_details);
// //       setTableloading(false);
// //       // setRowsPerPage(response?.data?.data?.pagination_details?.per_page)
// //     } catch (error) {
// //       //(error);
// //       if (error?.response?.data?.error == "No data found") {
// //         setVisitorsList([]);
// //       }
// //       setTableloading(false);
// //     }

//     // axiosInstance.get(`${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}`)
//     //   .then((data) => {
//     //     setVisitorsList(data.data.data.invite_visitor)
//     //     setPaginationData(data.data.data.pagination_details)
//     //   })
//     //   .catch((err) => {
//     //     //(err)
//     //   })
// //   };

// const getAllVisitors = async () => {
//   setTableloading(true)
//     try {
//         const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}all_visitors_history?page=${currentPage}&per_page=${rowsPerPage}&searchdata=${SearchData}&created_by=${userDetails?.user_role}&visitor_type=${TabId == "2" ? "Ad-hoc" : TabId == "1" ? "pre" : ""}&sort=${sortData}&type=old&from_date=${dateSubmit && datetimerangedata[0] ? moment(datetimerangedata[0]?.$d).format("YYYY-MM-DD") : ""}&to_date=${dateSubmit && datetimerangedata[1] ? moment(datetimerangedata[1]?.$d).format("YYYY-MM-DD") : ""}&company_id=${userDetails?.id}&role_id=${userDetails?.user_role}`);
//         //(response)
//         if(response.status === 200){
//             setVisitorsList(response.data.data);
//             setPaginationData(response.data.pagination_details);
//         }
//         setTableloading(false);
//     } catch (error) {
//         //(error.response.status, 'list devices')
//         if(error?.response?.status === 404){
//             setVisitorsList([]);
//         }
//         setTableloading(false);
//     }
// }

// //(paginationData)
//   useEffect(() => {
//     getAllVisitors();
//   }, [currentPage]);

//   useEffect(() => {
//     if (!initialRender) {
//       if (currentPage != 1) {
//         setCurrentPage(1);
//       } else {
//         getAllVisitors();
//       }
//     } else {
//       setInitialRender(false);
//     }
//   }, [TabId, sortData, rowsPerPage, SearchData, dateSubmit]);

//   // const handleSearch = async (data) => {

//   //   try {
//   //     const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}?search=${data}`)
//   //     setVisitorsList(response.data.data.invite_visitor)
//   //     setPaginationData(response.data.data.pagination_details)
//   //     setRowsPerPage(response?.data?.data?.pagination_details?.per_page)

//   //   } catch (error) {
//   //     //(error);
//   //   }
//   // }

//   const DownloadReport = async (type) => {
//     try {
//       setLoading(true);
//       setAnchorEl(false);
//       const response = await axiosInstance.get(
//         `${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}/download?download_type=${type}`,
//         { responseType: "blob" }
//       );
//       saveAs(response.data, `Visitors_report.${type}`);
//     } catch (error) {
//       //(error);
//       showToast("Something went wrong! Please try again.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getColumnType = () => {
//     switch (selectedTab) {
//       case "All":
//         return AccessHistoryAllTabColumn;
//       case "Invited":
//         return AccessHistoryAllTabColumn;
//       case "Ad-hoc":
//         return AccessHistoryAllTabColumn;
//       default:
//         return [];
//     }
//   };

//   const getNoDataType = () => {
//     switch (selectedTab) {
//       case "All":
//         return (
//           <>
//             <ExclamatoryIcon />
//             <Typography
//               sx={{
//                 color: "#9DA4AE",
//                 fontSize: "16px",
//                 fontWeight: 600,
//                 my: 2,
//               }}
//             >
//               No Visitor History
//             </Typography>
//             {/* <StyledSecondaryTypography color="#9DA4AE !important">
//               There are no pending, active or past visitors in the system at the
//               moment.{" "}
//             </StyledSecondaryTypography> */}
//           </>
//         );
//       case "Invited":
//         return (
//           <>
//             <ExclamatoryIcon />
//             <Typography
//               sx={{
//                 color: "#9DA4AE",
//                 fontSize: "16px",
//                 fontWeight: 600,
//                 my: 2,
//               }}
//             >
//               "No Invited Visitors found."
//             </Typography>
//             {/* <StyledSecondaryTypography color="#9DA4AE !important">
//               There are no pending, active or past visitors in the system at the
//               moment.{" "}
//             </StyledSecondaryTypography> */}
//           </>
//         );
//       case "Self Registration":
//         return (
//           <>
//             <ExclamatoryIcon />
//             <Typography
//               sx={{
//                 color: "#9DA4AE",
//                 fontSize: "16px",
//                 fontWeight: 600,
//                 my: 2,
//               }}
//             >
//               No Self Registration visitors found
//             </Typography>
//             {/* <StyledSecondaryTypography color="#9DA4AE !important">
//               There are no pending, active or past visitors in the system at the
//               moment.{" "}
//             </StyledSecondaryTypography> */}
//           </>
//         );
//       default:
//         return [];
//     }
//   };

//   const renderData = (value) => {
//     // switch (selectedTab) {
//     //   case 'All':
//     return (
//       <StyledTableRow height="70px">
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//             {value?.name || "-"}
//           </StyledSecondaryTypography>
//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//           {value?.email || "-"}
//           </StyledSecondaryTypography>
//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//           {value?.phone || "-"}
//           </StyledSecondaryTypography>
//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//           {value?.company_Name|| "-"}
//           </StyledSecondaryTypography>
//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//             IN
//           </StyledSecondaryTypography>
      
          

//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//           <StyledSecondaryTypography>
//           {value?.valid_to ? dayjs(value?.valid_to).format("DD MMM YYYY, hh:mm A") : "-"}
//           </StyledSecondaryTypography>
      
          

//         </StyledTableCell>
//         <StyledTableCell
//         //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
//         >
//             <StyledSecondaryTypography>
//             {`Invite Visitor`}
//             </StyledSecondaryTypography>
//         </StyledTableCell>
//       </StyledTableRow>
//     );
//     // }
//   };

//   const handleShowDeleteModal = () => {
//   setshowDeleteModal(!showDeleteModal);
// };

//   const deleteDevice = async () => {
//    try {
//      const response = await axiosInstance.delete(`${process.env.REACT_APP_API_URL}delete_visitor/${selectedDevice?.id}`);
//      if (response.status === 200) {
//        toast.success("Visitor deleted successfully");
//        handleShowDeleteModal()
//        getAllVisitors();
//      }
//    } catch (error) {
//      //(error);
//       toast.error("Something went wrong! Please try again.");
//   }
//   }

//   return (
//     <>
//     <ToastContainer
//                       autoClose='3000'
//                       position="bottom-center"
//                       toastClassName="custom-toast"
//                       hideProgressBar={true}
//                     />
//     {showDeleteModal && (
//         <AlertModal
//           modalDatas={deleteModalDatas}
//           confirmFunction={deleteDevice}
//           name={name}
//           closeFunction={handleShowDeleteModal}
//         />
//       )}
//       {openDateRangePicker && (
//               <CustomDateRangePicker
//                 openDateRangePicker={openDateRangePicker}
//                 setopenDateRangePicker={setopenDateRangePicker}
//                 datetimerangedata={datetimerangedata}
//                 setdatetimerangedata={setdatetimerangedata}
//                 setdateSubmit={setdateSubmit}
//               />
//             )}
//       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Box>
//           <PrimaryTypography>Visitor History</PrimaryTypography>
//           {/* <StyledSecondaryTypography>
//             View a list of all visitor invitations and registrations made via
//             the LOBY system.{" "}
//           </StyledSecondaryTypography> */}
//         </Box>
//         {/* <Button
//           onClick={(e) => setAnchorEl(e.currentTarget)}
//           sx={{
//             fontWeight: "600",
//             width: "fit-content",
//             color: "#800000",
//             backgroundColor: "#E7EFF3",
//             padding: "10px 16px 10px 16px",
//             "&:hover": {
//               backgroundColor: "#CFDFE6",
//             },
//             "&.Mui-disabled": {
//               backgroundColor: "#F9FAFB",
//               color: "#D2D6DB",
//             },
//           }}
//           disabled={VisitorsList.length === 0 || loading}
//         >
//           {loading ? (
//             <Box sx={{ width: "40px", marginTop: "5px" }}>
//               <CircularProgress size={15} />
//             </Box>
//           ) : VisitorsList.length > 0 ? (
//             <DownloadIcon style={{ marginRight: "8px", padding: "3px" }} />
//           ) : (
//             <DisabledDownloadIcon
//               style={{ marginRight: "8px", padding: "3px" }}
//             />
//           )}
//           Download Report
//         </Button> */}
//          {/* <Button
//                 onClick={() => navigate('add_visitor')}
//                 // variant="contained"
//                 // height="40px"
//                 sx={{
//                   height: "40px",
//                   padding: "10px 16px",
//                   borderRadius: "8px",
//                   backgroundColor: "#800000",
//                   color: "#FFF",
//                   fontSize: "14px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     backgroundColor: "#800000",
//                   },
//                 }}
//               >
//                 {"Add"}
//               </Button> */}
//       </Box>

//       <Box
//         sx={{
//           backgroundColor: "#FFFFFF",
//           border: "1px solid #E5E7EB",
//           p: 3,
//           mt: 4,
//           borderRadius: " 8px 8px 0px 0px",
//           display: "flex",
//           justifyContent: "space-between",
//           overflowX: "scroll",
//           "::-webkit-scrollbar": { display: "none" },
//         }}
//       >
//         <Box
//           sx={{
//             border: "1px solid #D2D6DB",
//             display: "flex",
//             borderRadius: "10px",
//           }}
//         >
//           {tabList.map((value, index) => (
//             <Box
//               onClick={() => {
//                 setSelectedTab(value);
//                 setTabId(index == 0 ? "" : index);
//               }}
//               sx={{
//                 borderLeft: index !== 0 ? "1px solid #E5E7EB" : "initial",
//                 backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
//                 padding: "10px 16px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 borderRadius:
//                   index == 0
//                     ? " 8px 0 0 8px "
//                     : index == 2
//                     ? "0px 8px 8px 0px"
//                     : "initial",
//                 "&:hover": { cursor: "pointer" },
//               }}
//             >
//               <Typography
//                 sx={{
//                   color: value === selectedTab ? "#111927" : "#4D5761",
//                   fontSize: "14px",
//                   fontWeight: 550,
//                 }}
//                 textAlign={"center"}
//               >
//                 {value}
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//         <Box sx={{ display: "flex", height: "40px" }}>
//           <StyledOutlinedInput
//             placeholder="Search"
//             onChange={(e) => {
//               setSearchData(e.target.value);
//             }}
//             startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
//           />
//           <Box
//                             onClick={() => {
//                               setopenDateRangePicker(true);
//                             }}
//                             sx={{
//                               minWidth: "237px",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               border: "1px solid #D2D6DB",
//                               borderRadius: "8px",
//                               px: 2,
//                               ml: 2,
//                               "&:hover": {
//                                 cursor: "pointer",
//                                 backgroundColor: "#F9FAFB",
//                               },
//                             }}
//                           >
//                             <DatePickerIcon style={{ marginRight: "10px" }} />
//                             <StyledSecondaryBookingTypography>
//                               {Boolean(datetimerangedata[0])
//                                 ? moment(datetimerangedata[0]?.$d).format("MMM D YYYY")
//                                 : "MMM DD YYY"}{" "}
//                               -{" "}
//                               {Boolean(datetimerangedata[1])
//                                 ? moment(datetimerangedata[1]?.$d).format("MMM D YYYY")
//                                 : "MMM DD YYY"}
//                             </StyledSecondaryBookingTypography>
//                           </Box>
//           <Box
//             onClick={(e) => setSortAnchorEl(e.currentTarget)}
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               border: "1px solid #D2D6DB",
//               borderRadius: "6px",
//               px: 2,
//               ml: 2,
//               "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
//             }}
//           >
//             <SortIcon style={{ marginRight: "10px" }} />
//             <SecondaryTypography>Sort</SecondaryTypography>
//           </Box>
//           {/* <Box onClick={(e) => setFilterAnchorEl(e.currentTarget)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E5E7EB', borderRadius: '6px', px: 2, ml: 2 }}>
//             <FilterIcon style={{ marginRight: '10px' }} />
//             <SecondaryTypography>Filters</SecondaryTypography>
//           </Box> */}
//         </Box>
//       </Box>

//       <Box
//         sx={{ border: "1px solid #E5E7EB", borderRadius: "0px 0px 8px 8px" }}
//       >
//         <>
//           <TableContainer>
//             {Tableloading ? (
//               <Box sx={{ display: "flex", justifyContent: "center" }}>
//                 <CircularProgress style={{ margin: "20px" }} />
//               </Box>
//             ) : (
//  <Table>
//               <TableHead>
//                 {VisitorsList?.length > 0 && (
//                   <StyledTableRow>
//                     {getColumnType().map((value) => {
//                       return (
//                         <StyledTableCell>
//                           {value === "Checkbox" ? (
//                             <Checkbox size="small" icon={<CheckboxIcon />} />
//                           ) : value === "More" ? (
//                             ""
//                           ) : (
//                             value
//                           )}
//                         </StyledTableCell>
//                       );
//                     })}
//                   </StyledTableRow>
//                 )}
//               </TableHead>
//               <TableBody bgColor={!VisitorsList.length > 0 && "#F9FAFB"}>
//                 {VisitorsList?.length > 0 ? (
//                   VisitorsList?.map((value) => {
//                     return renderData(value);
//                   })
//                 ) : (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       height: "50vh",
//                       justifyContent: "center",
//                     }}
//                   >
//                     {Tableloading ? <CircularProgress /> : getNoDataType()}
//                   </Box>
//                 )}
//               </TableBody>
//             </Table>
//             )}
           
//           </TableContainer>

//           {!Tableloading && VisitorsList?.length > 0 && (
//             <Box
//               sx={{
//                 backgroundColor: "#FFFFFF",
//                 borderTopStyle: "none !important",
//                 // border: "1px solid #E5E7EB",
//                 borderRadius: "0px 0px 8px 8px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 p: 2.5,
//               }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <Typography
//                   sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
//                 >
//                   Show :
//                 </Typography>
//                 {/* <OutlinedInput inputProps={{ min: 5, max: 30, step: 5 }} value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)} type='number' sx={{ height: '40px', width: '100px', ml: 2, borderRadius: '8px' }} /> */}
//                 <Box
//                   onClick={(e) => setshowAnchorEl(e.currentTarget)}
//                   sx={{
//                     width: "95px",
//                     height: "40px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     border: "1px solid #E5E7EB",
//                     borderRadius: "6px",
//                     ml: 2,
//                     "&:hover": { cursor: "pointer" },
//                   }}
//                 >
//                   <Typography
//                     sx={{ fontSize: "15px" }}
//                     display="flex"
//                     alignItems="center"
//                     justifyContent="space-between"
//                   >
//                     {rowsPerPage} rows{" "}
//                     <NumberInputIcon style={{ paddingLeft: "5px" }} />
//                   </Typography>
//                 </Box>
//               </Box>
//               <Pagination
//                 size="medium"
//                 page={currentPage}
//                 count={paginationData?.last_page}
//                 onChange={(e, value) => setCurrentPage(value)}
//                 shape="rounded"
//                 renderItem={(item) => (
//                   <PaginationItem
//                     slots={{ previous: PreviousIcon, next: NextIcon }}
//                     {...item}
//                   />
//                 )}
//               />
//             </Box>
//           )}
//         </>
//       </Box>
//       <Menu
//         sx={{ m: 0.5 }}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={() => setAnchorEl(null)}
//       >
//         <MenuItem>
//           <TypographyDefault
//             py={0.5}
//             sx={{
//               fontWeight: "500 !important",
//               color: "#1F2A37 !important",
//               display: "flex",
//             }}
//             onClick={() => DownloadReport("csv")}
//           >
//             <CsvIcon width={40} /> Download as CSV file
//           </TypographyDefault>
//         </MenuItem>
//         <MenuItem>
//           <TypographyDefault
//             py={0.5}
//             sx={{
//               fontWeight: "500 !important",
//               color: "#1F2A37 !important",
//               display: "flex",
//             }}
//             onClick={() => DownloadReport("pdf")}
//           >
//             <PdfIcon width={40} />
//             Download as PDF file
//           </TypographyDefault>
//         </MenuItem>
//       </Menu>
//       <Menu
//         sx={{ m: 0.5 }}
//         open={sortOpen}
//         anchorEl={sortAnchorEl}
//         onClose={() => setSortAnchorEl(null)}
//       >
//         <MenuItem
//           sx={{ backgroundColor: sortData == "all" ? "#eff3f5" : "" }}
//           onClick={() => {
//             setSortData("all");
//             setSortAnchorEl(null);
//           }}
//         >
//           <Typography py={0.3}>All</Typography>
//         </MenuItem>
//         <MenuItem
//           sx={{ backgroundColor: sortData == "future" ? "#eff3f5" : "" }}
//           onClick={() => {
//             setSortData("future");
//             setSortAnchorEl(null);
//           }}
//         >
//           <Typography py={0.3}>Upcoming</Typography>
//         </MenuItem>
//         <MenuItem
//           sx={{ backgroundColor: sortData == "current" ? "#eff3f5" : "" }}
//           onClick={() => {
//             setSortData("current");
//             setSortAnchorEl(null);
//           }}
//         >
//           <Typography py={0.3}>Current</Typography>
//         </MenuItem>
//         {/* <MenuItem>
//           <Typography py={.3}>Most Visitors First</Typography>
//         </MenuItem>
//         <MenuItem>
//           <Typography py={.3}>Least Visitors First</Typography>
//         </MenuItem> */}
//       </Menu>
//       <Menu
//         sx={{ m: 0.5 }}
//         open={filterOpen}
//         anchorEl={filterAnchorEl}
//         onClose={() => setFilterAnchorEl(null)}
//       >
//         <MenuItem>
//           <Checkbox icon={<CheckboxIcon />} />
//           <Typography sx={{ mr: 3 }}>Management</Typography>
//         </MenuItem>
//         <MenuItem>
//           <Checkbox icon={<CheckboxIcon />} />
//           <Typography>Operations</Typography>
//         </MenuItem>
//         <MenuItem>
//           <Checkbox icon={<CheckboxIcon />} />
//           <Typography>Ground Staff</Typography>
//         </MenuItem>
//       </Menu>

//       <Menu
//         sx={{ m: 0.5 }}
//         open={showOpen}
//         anchorEl={showAnchorEl}
//         onClose={() => setshowAnchorEl(null)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "left" }}
//       >
//         <MenuItem
//           onClick={() => {
//             setRowsPerPage(10);
//             setshowAnchorEl(null);
//           }}
//         >
//           <Typography>10 rows</Typography>
//         </MenuItem>
//         <MenuItem
//           onClick={() => {
//             setRowsPerPage(20);
//             setshowAnchorEl(null);
//           }}
//         >
//           <Typography>20 rows</Typography>
//         </MenuItem>
//         <MenuItem
//           onClick={() => {
//             setRowsPerPage(30);
//             setshowAnchorEl(null);
//           }}
//         >
//           <Typography>30 rows</Typography>
//         </MenuItem>
//         <MenuItem
//           onClick={() => {
//             setRowsPerPage(40);
//             setshowAnchorEl(null);
//           }}
//         >
//           <Typography>40 rows</Typography>
//         </MenuItem>
//         <MenuItem
//           onClick={() => {
//             setRowsPerPage(50);
//             setshowAnchorEl(null);
//           }}
//         >
//           <Typography>50 rows</Typography>
//         </MenuItem>
//       </Menu>
//     </>
//   );
// };

// export default VisitorAccessReports;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Modal,
  OutlinedInput,
  Pagination,
  CircularProgress,
  PaginationItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  IconButton,
} from "@mui/material";
import {
  DatePickerStyle,
  PrimaryTypography,
  SecondaryTypography,
  StyledOutlinedInput,
  StyledSecondaryTypography,
  StyledTableCell,
  StyledTableRow,
  StyledTypography,
  TypographyDefault,
  StyledSecondaryBookingTypography,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as FilterIcon } from "../../Icons/Filter.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as CsvIcon } from "../../Icons/CsvIcon.svg";
import { ReactComponent as PdfIcon } from "../../Icons/PdfIcon.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/DownloadIcon.svg";
import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
import { ReactComponent as CheckboxIcon } from "../../Icons/Checkbox.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/DeleteTable.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import { ReactComponent as MoreIcon } from "../../Icons/ThreeDot.svg";
import { ReactComponent as Close } from "../../Icons/BorderAlertClose.svg";
import { ReactComponent as DisabledDownloadIcon } from "../../Icons/DisableDownload.svg";
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import { AccessHistoryAllTabColumn } from "../../Data";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../Redux/AxiosInstance";
import moment from "moment";
import { getChip } from "../../Utils";
import TypesInformationModal from "../../CommonComponents/TypeInformationModal";
import { DatePicker } from "@mui/x-date-pickers";
import { showToast } from "../../CommonComponents/Toaster";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import AlertModal from "../../CommonComponents/modal";
import { toast, ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../CommonComponents/CustomDateRange";

const VisitorAccessReports = () => {
  const [initialRender, setInitialRender] = useState(true);
  const { propertyId } = useSelector((state) => state.PropertyDetails);
  const [openDateRangePicker, setopenDateRangePicker] = useState(false);
  const { userDetails } = useSelector((state) => state.Login);
  //(userDetails)
  const tabList = ["All", "Invited", "Ad-hoc"];
  const [TabId, setTabId] = useState("");
  //(TabId);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState("All");
  const [VisitorsList, setVisitorsList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState("10");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const sortOpen = Boolean(sortAnchorEl);
  const [sortData, setSortData] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterOpen = Boolean(filterAnchorEl);
  const [paginationData, setPaginationData] = useState({});
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const showOpen = Boolean(showAnchorEl);
  const [SearchData, setSearchData] = useState("");
  const [Tableloading, setTableloading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
   const [dateSubmit, setdateSubmit] = useState("callApi");
   const [debouncedSearch, setDebouncedSearch] = useState(SearchData);
   //(dateSubmit);
  const userRoles = {
    '2' : 'BMO Admin',
    '3' : 'Concierge',
    '4' : 'Security',
    '5' : 'Manager',
  }
  const [datetimerangedata, setdatetimerangedata] = useState([null, null]);

  let name ="", id = "";
  let deleteModalDatas = {
    label:  "Delete User",
    descriptionOne:  `User will be removed from the list.`,
    buttonOne: {
      variant: "outlined",
      color: "#800000",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#B42318",
      text: "Delete Now",
    },
  };

//   const getAllVisitors = async () => {
//     setTableloading(true);
//     setVisitorsList([]);
//     try {
//       const response = await axiosInstance.get(
//         `${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&sort=${sortData}&type_id=${TabId}&search=${SearchData}`
//       );
//       setVisitorsList(response.data.data.invite_visitor);
//       setPaginationData(response.data.data.pagination_details);
//       setTableloading(false);
//       // setRowsPerPage(response?.data?.data?.pagination_details?.per_page)
//     } catch (error) {
//       //(error);
//       if (error?.response?.data?.error == "No data found") {
//         setVisitorsList([]);
//       }
//       setTableloading(false);
//     }

    // axiosInstance.get(`${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}`)
    //   .then((data) => {
    //     setVisitorsList(data.data.data.invite_visitor)
    //     setPaginationData(data.data.data.pagination_details)
    //   })
    //   .catch((err) => {
    //     //(err)
    //   })
//   };

const getAllVisitors = async () => {
  setTableloading(true)
    try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}visitor_access_report?page=${currentPage}&per_page=${rowsPerPage}&searchdata=${debouncedSearch}&created_by=${userDetails?.user_role}&visitor_type=${TabId == "2" ? "Ad-hoc" : TabId == "1" ? "pre" : ""}&sort=${sortData}&type=upcoming&from_date=${dateSubmit && datetimerangedata[0] ? moment(datetimerangedata[0]?.$d).format("YYYY-MM-DD") : ""}&to_date=${dateSubmit && datetimerangedata[1] ? moment(datetimerangedata[1]?.$d).format("YYYY-MM-DD") : ""}&company_id=${userDetails?.company_user_id || null}&role_id=${userDetails?.user_role}`);
        //(response)
        if(response.status === 200){
            setVisitorsList(response.data.data);
            setPaginationData(response.data.pagination_details);
        }
        setTableloading(false);
    } catch (error) {
        //(error.response.status, 'list devices')
        if(error?.response?.status === 403 && error?.response?.data?.detail =="User not found" || error?.response?.data?.detail == "Access Denied"){
      localStorage.clear();
      window.location.href = "/login";
    }
        if(error?.response?.status === 404){
            setVisitorsList([]);
        }
        setTableloading(false);
    }
}

//(paginationData)
  useEffect(() => {
    getAllVisitors();
  }, [currentPage]);

  useEffect(() => {
    if (!initialRender) {
      if (currentPage != 1) {
        setCurrentPage(1);
      } else {
        getAllVisitors();
      }
    } else {
      setInitialRender(false);
    }
  }, [TabId, sortData, rowsPerPage, debouncedSearch]);

  useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(SearchData);
  }, 500); // 500ms delay

  return () => {
    clearTimeout(handler);
  };
}, [SearchData]);

  useEffect(() => {
      if(dateSubmit === "callApi" || dateSubmit === "start"){
      if (!initialRender) {
        if (currentPage != 1) {
          setCurrentPage(1);
        } else {
          getAllVisitors();
        }
      } else {
        setInitialRender(false);
      }
      }
      setdateSubmit("hold")
    }, [dateSubmit]);

  // const handleSearch = async (data) => {

  //   try {
  //     const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}?search=${data}`)
  //     setVisitorsList(response.data.data.invite_visitor)
  //     setPaginationData(response.data.data.pagination_details)
  //     setRowsPerPage(response?.data?.data?.pagination_details?.per_page)

  //   } catch (error) {
  //     //(error);
  //   }
  // }


//     const DownloadReport = (format) => {
//   setAnchorEl(false);

//   const url = `${process.env.REACT_APP_API_URL}visitor_access_report?download=true&role_id=${userDetails?.user_role}&company_id=${userDetails?.company_user_id}&visitor_type=${TabId == "2" ? "Ad-hoc" : TabId == "1" ? "pre" : ""}&from_date=${dateSubmit && datetimerangedata[0] ? moment(datetimerangedata[0]?.$d).format("YYYY-MM-DD") : ""}&to_date=${dateSubmit && datetimerangedata[1] ? moment(datetimerangedata[1]?.$d).format("YYYY-MM-DD") : ""}&download_type=${format}`;

//   window.open(url, "_blank");
// };

const getTimestamp = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");      // 24hr format
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};

const DownloadReport = async (format) => {
  setAnchorEl(false);

  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}visitor_access_report`,
      {
        params: {
          download: true,
          role_id: userDetails?.user_role,
          company_id: userDetails?.company_user_id,
          download_type: format,
          visitor_type: TabId == "2" ? "Ad-hoc" : TabId == "1" ? "pre" : "",
          from_date: dateSubmit && datetimerangedata[0] ? moment(datetimerangedata[0]?.$d).format("YYYY-MM-DD") : "",
          to_date: dateSubmit && datetimerangedata[1] ? moment(datetimerangedata[1]?.$d).format("YYYY-MM-DD") : ""
        },
        responseType: "blob", // VERY IMPORTANT
      }
    );

    // Create file URL
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);

    // Create temporary link
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Optional: set dynamic file name
    const timestamp = getTimestamp();
    link.setAttribute("download", `Visitors_Access_Report_${timestamp}.${format}`);

    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

  } catch (error) {
    //.error("Download failed", error);
  }
};

  const getColumnType = () => {
    switch (selectedTab) {
      case "All":
        return AccessHistoryAllTabColumn;
      case "Invited":
        return AccessHistoryAllTabColumn;
      case "Ad-hoc":
        return AccessHistoryAllTabColumn;
      default:
        return [];
    }
  };

  const getNoDataType = () => {
    switch (selectedTab) {
      case "All":
        return (
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Visitor Access Reports Found.
            </Typography>
            {/* <StyledSecondaryTypography color="#9DA4AE !important">
              There are no pending, active or past visitors in the system at the
              moment.{" "}
            </StyledSecondaryTypography> */}
          </>
        );
      case "Invited":
        return (
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Invited Visitors Access Reports Found.
            </Typography>
            {/* <StyledSecondaryTypography color="#9DA4AE !important">
              There are no pending, active or past visitors in the system at the
              moment.{" "}
            </StyledSecondaryTypography> */}
          </>
        );
      case "Ad-hoc":
        return (
          <>
            <ExclamatoryIcon />
            <Typography
              sx={{
                color: "#9DA4AE",
                fontSize: "16px",
                fontWeight: 600,
                my: 2,
              }}
            >
              No Ad-hoc visitors Access Reports Found.
            </Typography>
            {/* <StyledSecondaryTypography color="#9DA4AE !important">
              There are no pending, active or past visitors in the system at the
              moment.{" "}
            </StyledSecondaryTypography> */}
          </>
        );
      default:
        return [];
    }
  };

  const renderData = (value, index) => {
    // switch (selectedTab) {
    //   case 'All':
    const serialNumber = (currentPage - 1) * rowsPerPage + (index + 1);
    return (
      <StyledTableRow height="70px">
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
            {serialNumber}
          </StyledSecondaryTypography>
        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
            {value?.visitor_name || "-"}
          </StyledSecondaryTypography>
        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
          {value?.visitor_email || "-"}
          </StyledSecondaryTypography>
        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
          {value?.visitor_phone || "-"}
          </StyledSecondaryTypography>
        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
          {value?.company_name|| "-"}
          </StyledSecondaryTypography>
        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
            {value?.entry_time ? dayjs(value?.entry_time).format("DD MMM YYYY, hh:mm A") : "-"}
          </StyledSecondaryTypography>
      
          

        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
          <StyledSecondaryTypography>
          {value?.exit_time ? dayjs(value?.exit_time).format("DD MMM YYYY, hh:mm A") : "-"}
          
          </StyledSecondaryTypography>
      
          

        </StyledTableCell>
        <StyledTableCell
        //   onClick={() => navigate(`visitorsDetails/${value.id}`)}
        >
            <StyledSecondaryTypography>
            {value?.visitor_source || "-"}
            </StyledSecondaryTypography>
        </StyledTableCell>
      </StyledTableRow>
    );
    // }
  };

  const handleShowDeleteModal = () => {
  setshowDeleteModal(!showDeleteModal);
};

  const deleteDevice = async () => {
   try {
     const response = await axiosInstance.delete(`${process.env.REACT_APP_API_URL}delete_visitor/${selectedDevice?.id}`);
     if (response.status === 200) {
       toast.success("Visitor deleted successfully");
       handleShowDeleteModal()
       getAllVisitors();
     }
   } catch (error) {
     //(error);
      toast.error("Something went wrong! Please try again.");
  }
  }

  return (
    <>
    <ToastContainer
                      autoClose='3000'
                      position="bottom-center"
                      toastClassName="custom-toast"
                      hideProgressBar={true}
                    />
    {showDeleteModal && (
        <AlertModal
          modalDatas={deleteModalDatas}
          confirmFunction={deleteDevice}
          name={name}
          closeFunction={handleShowDeleteModal}
        />
      )}
      {openDateRangePicker && (
              <CustomDateRangePicker
                openDateRangePicker={openDateRangePicker}
                setopenDateRangePicker={setopenDateRangePicker}
                datetimerangedata={datetimerangedata}
                setdatetimerangedata={setdatetimerangedata}
                setdateSubmit={setdateSubmit}
              />
            )}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <PrimaryTypography>Visitor Access Report</PrimaryTypography>
          {/* <StyledSecondaryTypography>
            View a list of all visitor invitations and registrations made via
            the LOBY system.{" "}
          </StyledSecondaryTypography> */}
        </Box>
        <Button
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{
            fontWeight: "600",
            width: "fit-content",
            color: "#800000",
            backgroundColor: "#f3e7e7ff",
            padding: "10px 16px 10px 16px",
            "&:hover": {
              backgroundColor: "#e6cfcfff",
            },
            "&.Mui-disabled": {
              backgroundColor: "#F9FAFB",
              color: "#D2D6DB",
            },
          }}
          disabled={VisitorsList.length === 0 || loading}
        >
          {loading ? (
            <Box sx={{ width: "40px", marginTop: "5px" }}>
              <CircularProgress size={15} />
            </Box>
          ) : VisitorsList.length > 0 ? (
            <DownloadIcon style={{ marginRight: "8px", padding: "3px" }} />
          ) : (
            <DisabledDownloadIcon
              style={{ marginRight: "8px", padding: "3px" }}
            />
          )}
          Download Report
        </Button>
         {/* <Button
                onClick={() => navigate('add_visitor')}
                // variant="contained"
                // height="40px"
                sx={{
                  height: "40px",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  backgroundColor: "#800000",
                  color: "#FFF",
                  fontSize: "14px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#800000",
                  },
                }}
              >
                {"Add"}
              </Button> */}
      </Box>

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          p: 3,
          mt: 4,
          borderRadius: " 8px 8px 0px 0px",
          display: "flex",
          justifyContent: "space-between",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            border: "1px solid #D2D6DB",
            display: "flex",
            borderRadius: "10px",
          }}
        >
          {tabList.map((value, index) => (
            <Box
              onClick={() => {
                setSelectedTab(value);
                setTabId(index == 0 ? "" : index);
              }}
              sx={{
                borderLeft: index !== 0 ? "1px solid #E5E7EB" : "initial",
                backgroundColor: value == selectedTab ? "#F3F4F6" : "initial",
                padding: "10px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius:
                  index == 0
                    ? " 8px 0 0 8px "
                    : index == 2
                    ? "0px 8px 8px 0px"
                    : "initial",
                "&:hover": { cursor: "pointer" },
              }}
            >
              <Typography
                sx={{
                  color: value === selectedTab ? "#111927" : "#4D5761",
                  fontSize: "14px",
                  fontWeight: 550,
                }}
                textAlign={"center"}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", height: "40px" }}>
          <StyledOutlinedInput
            placeholder="Search"
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />
          <Box
                            onClick={() => {
                              setopenDateRangePicker(true);
                            }}
                            sx={{
                              minWidth: "237px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "1px solid #D2D6DB",
                              borderRadius: "8px",
                              px: 2,
                              ml: 2,
                              "&:hover": {
                                cursor: "pointer",
                                backgroundColor: "#F9FAFB",
                              },
                            }}
                          >
                            <DatePickerIcon style={{ marginRight: "10px" }} />
                            <StyledSecondaryBookingTypography>
                              {Boolean(datetimerangedata[0])
                                ? moment(datetimerangedata[0]?.$d).format("MMM D YYYY")
                                : "MMM DD YYY"}{" "}
                              -{" "}
                              {Boolean(datetimerangedata[1])
                                ? moment(datetimerangedata[1]?.$d).format("MMM D YYYY")
                                : "MMM DD YYY"}
                            </StyledSecondaryBookingTypography>
                          </Box>
          {/* <Box
            onClick={(e) => setSortAnchorEl(e.currentTarget)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #D2D6DB",
              borderRadius: "6px",
              px: 2,
              ml: 2,
              "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
            }}
          >
            <SortIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>Sort</SecondaryTypography>
          </Box> */}
          {/* <Box onClick={(e) => setFilterAnchorEl(e.currentTarget)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E5E7EB', borderRadius: '6px', px: 2, ml: 2 }}>
            <FilterIcon style={{ marginRight: '10px' }} />
            <SecondaryTypography>Filters</SecondaryTypography>
          </Box> */}
        </Box>
      </Box>

      <Box
        sx={{ border: "1px solid #E5E7EB", borderRadius: "0px 0px 8px 8px" }}
      >
        <>
          <TableContainer>
            {Tableloading ? (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress style={{ margin: "20px" }} />
              </Box>
            ) : (
 <Table>
              <TableHead>
                {VisitorsList?.length > 0 && (
                  <StyledTableRow>
                    {getColumnType().map((value) => {
                      return (
                        <StyledTableCell>
                          {value === "Checkbox" ? (
                            <Checkbox size="small" icon={<CheckboxIcon />} />
                          ) : value === "More" ? (
                            ""
                          ) : (
                            value
                          )}
                        </StyledTableCell>
                      );
                    })}
                  </StyledTableRow>
                )}
              </TableHead>
              <TableBody bgColor={!VisitorsList.length > 0 && "#F9FAFB"}>
                {VisitorsList?.length > 0 ? (
                  VisitorsList?.map((value, index) => {
                    return renderData(value, index);
                  })
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "50vh",
                      justifyContent: "center",
                    }}
                  >
                    {Tableloading ? <CircularProgress /> : getNoDataType()}
                  </Box>
                )}
              </TableBody>
            </Table>
            )}
           
          </TableContainer>

          {!Tableloading && VisitorsList?.length > 0 && (
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                borderTopStyle: "none !important",
                // border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
                >
                  Show :
                </Typography>
                {/* <OutlinedInput inputProps={{ min: 5, max: 30, step: 5 }} value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)} type='number' sx={{ height: '40px', width: '100px', ml: 2, borderRadius: '8px' }} /> */}
                <Box
                  onClick={(e) => setshowAnchorEl(e.currentTarget)}
                  sx={{
                    width: "95px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px",
                    ml: 2,
                    "&:hover": { cursor: "pointer" },
                  }}
                >
                  <Typography
                    sx={{ fontSize: "15px" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {rowsPerPage} rows{" "}
                    <NumberInputIcon style={{ paddingLeft: "5px" }} />
                  </Typography>
                </Box>
              </Box>
              <Pagination
                size="medium"
                page={currentPage}
                count={paginationData?.last_page}
                onChange={(e, value) => setCurrentPage(value)}
                shape="rounded"
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: PreviousIcon, next: NextIcon }}
                    {...item}
                  />
                )}
              />
            </Box>
          )}
        </>
      </Box>
      <Menu
        sx={{ m: 0.5 }}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem>
          <TypographyDefault
            py={0.5}
            sx={{
              fontWeight: "500 !important",
              color: "#1F2A37 !important",
              display: "flex",
            }}
            onClick={() => DownloadReport("xlsx")}
          >
            Download as Excel file
          </TypographyDefault>
        </MenuItem>
        <MenuItem>
          <TypographyDefault
            py={0.5}
            sx={{
              fontWeight: "500 !important",
              color: "#1F2A37 !important",
              display: "flex",
            }}
            onClick={() => DownloadReport("pdf")}
          >
            Download as PDF file
          </TypographyDefault>
        </MenuItem>
        {/* <MenuItem>
          <TypographyDefault
            py={0.5}
            sx={{
              fontWeight: "500 !important",
              color: "#1F2A37 !important",
              display: "flex",
            }}
            onClick={() => DownloadReport("pdf")}
          >
            <PdfIcon width={40} />
            Download as PDF file
          </TypographyDefault>
        </MenuItem> */}
      </Menu>
      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        <MenuItem
          sx={{ backgroundColor: sortData == "all" ? "#eff3f5" : "" }}
          onClick={() => {
            setSortData("all");
            setSortAnchorEl(null);
          }}
        >
          <Typography py={0.3}>All</Typography>
        </MenuItem>
        <MenuItem
          sx={{ backgroundColor: sortData == "future" ? "#eff3f5" : "" }}
          onClick={() => {
            setSortData("future");
            setSortAnchorEl(null);
          }}
        >
          <Typography py={0.3}>Upcoming</Typography>
        </MenuItem>
        <MenuItem
          sx={{ backgroundColor: sortData == "current" ? "#eff3f5" : "" }}
          onClick={() => {
            setSortData("current");
            setSortAnchorEl(null);
          }}
        >
          <Typography py={0.3}>Current</Typography>
        </MenuItem>
        {/* <MenuItem>
          <Typography py={.3}>Most Visitors First</Typography>
        </MenuItem>
        <MenuItem>
          <Typography py={.3}>Least Visitors First</Typography>
        </MenuItem> */}
      </Menu>
      <Menu
        sx={{ m: 0.5 }}
        open={filterOpen}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
      >
        <MenuItem>
          <Checkbox icon={<CheckboxIcon />} />
          <Typography sx={{ mr: 3 }}>Management</Typography>
        </MenuItem>
        <MenuItem>
          <Checkbox icon={<CheckboxIcon />} />
          <Typography>Operations</Typography>
        </MenuItem>
        <MenuItem>
          <Checkbox icon={<CheckboxIcon />} />
          <Typography>Ground Staff</Typography>
        </MenuItem>
      </Menu>

      <Menu
        sx={{ m: 0.5 }}
        open={showOpen}
        anchorEl={showAnchorEl}
        onClose={() => setshowAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setRowsPerPage(10);
            setshowAnchorEl(null);
          }}
        >
          <Typography>10 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(20);
            setshowAnchorEl(null);
          }}
        >
          <Typography>20 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(30);
            setshowAnchorEl(null);
          }}
        >
          <Typography>30 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(40);
            setshowAnchorEl(null);
          }}
        >
          <Typography>40 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(50);
            setshowAnchorEl(null);
          }}
        >
          <Typography>50 rows</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default VisitorAccessReports;
